import { COLORS } from '@app/constants';
import styled from 'styled-components';

export const DerivativesTransactionWrapper = styled.div`
  height: auto;
  width: 100%;
  overflow: visible;
  color: ${COLORS.greyWhite};
`;
